/* global gsap, ScrollTrigger, SplitText, Lenis */

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

// lenis
const lenis = new Lenis();
lenis.on("scroll", () => {
  ScrollTrigger.update;
});
gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

// dom loaded
document.addEventListener("DOMContentLoaded", function () {
  document.body.classList.add('dom_loaded')
});
// window loaded
window.addEventListener("load", () => {
    document.body.classList.add('window_loaded');
});

// grid overlay
const grid_overlay = document.getElementById('grid-overlay');
if(grid_overlay){
  document.addEventListener('keydown', function (event) {
    if (event.ctrlKey && event.key.toLowerCase() === 'g') {
      event.preventDefault();
      grid_overlay.classList.toggle('hidden');
    }
  });
}


// localtime
(function () {
  const module_localtime = document.querySelector('section[data-module="localtime"]');

  if (!module_localtime) return;

  const timeEl = module_localtime.querySelector(".time");
  const lineEl = module_localtime.querySelector(".line");
  let intervalId = null;
  let isVisible = false;

  function updateTime() {
    const now = new Date();

    // Get Copenhagen time string with hours, minutes, am/pm only
    const options = {
      timeZone: "Europe/Copenhagen",
      hour: "2-digit",
      minute: "2-digit",
      second: '2-digit',
      hour12: true
    };
    timeEl.textContent = now.toLocaleTimeString("en-US", options);

    // Get seconds in Copenhagen timezone for line position
    const cph = new Date(
      now.toLocaleString("en-US", { timeZone: "Europe/Copenhagen" })
    );
    const seconds = cph.getSeconds();

    const percentOfMinute = (seconds / 60) * 100;

    // Update horizontal position of line according to seconds (0-60)
    lineEl.style.transform = `translate3d(${percentOfMinute}%, 0, 0)`;
  }

  function startClock() {
    if (intervalId) return;
    updateTime();

    const delay = 1000 - (Date.now() % 1000);
    setTimeout(() => {
      updateTime();
      intervalId = setInterval(updateTime, 1000);
    }, delay);
  }

  function stopClock() {
    clearInterval(intervalId);
    intervalId = null;
  }

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      stopClock();
    } else if (isVisible) {
      startClock();
    }
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isVisible = entry.isIntersecting;
        if (isVisible && !document.hidden) {
          startClock();
        } else {
          stopClock();
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "100px"
    }
  );

  observer.observe(module_localtime);
})();


// section product_list
const product_cards = document.querySelectorAll('[data-card="product"]');
let activeCell = null;

function updateDistances(cell, x, y) {
  const rect = cell.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;
  const dx = Math.round(x - centerX);
  const dy = Math.round(y - centerY);
  cell.style.setProperty('--dx', dx + 'px');
  cell.style.setProperty('--dy', dy + 'px');
}

function resetDistances(cell) {
  cell.style.setProperty('--dx', '0px');
  cell.style.setProperty('--dy', '0px');
}

// Mouse events
product_cards.forEach(cell => {
  cell.addEventListener('mouseenter', () => {
    activeCell = cell;
    cell.classList.add('active');
  });

  cell.addEventListener('mouseleave', () => {
    resetDistances(cell);
    cell.classList.remove('active');
    activeCell = null;
  });
});

document.addEventListener('mousemove', e => {
  if (activeCell) {
    updateDistances(activeCell, e.clientX, e.clientY);
  }
});

// Touch events
product_cards.forEach(product_card => {
  product_card.addEventListener('touchstart', e => {
    activeCell = product_card;
    product_card.classList.add('active');
    updateDistances(product_card, e.touches[0].clientX, e.touches[0].clientY);
  }, { passive: true });

  product_card.addEventListener('touchmove', e => {
    if (activeCell === product_card) {
      updateDistances(product_card, e.touches[0].clientX, e.touches[0].clientY);
    }
  }, { passive: true });

  product_card.addEventListener('touchend', () => {
    resetDistances(product_card);
    product_card.classList.remove('active');
    activeCell = null;
  });
});


// footer animation
function footerAnimation(init) {
  window.addEventListener("load", () => {
    const footer_logo_element = document.querySelector("footer .footer .content");
    const footer_footer = document.querySelector("footer .footer");
    if (init && footer_logo_element && footer_footer) {
      gsap.fromTo(
        footer_logo_element,
        {
          yPercent: 100,
          filter: "blur(24px)"
        },
        {
          yPercent: 0,
          filter: "blur(0px)",
          ease: "none",
          duration: 1,
          scrollTrigger: {
            trigger: footer_footer,
            start: "top bottom",
            end: "bottom bottom",
            scrub: true,
            toggleActions: "play none none reverse"
          }
        }
      );
    }
  });
}
footerAnimation(false);

// menu toggle button
function initMenuButton() {
  const menuContent = document.querySelector("#menu .content");
  const menuButton = document.querySelector('[data-action="toggle_menu"]');

  if (!menuContent && !menuButton) {
    return;
  }

  menuButton.addEventListener("click", function (e) {
    e.preventDefault(); // Prevents link default behavior
    document.body.classList.toggle("menu_active");

    if (document.body.classList.contains("menu_active")) {
      //lenis.stop(); // Disable scroll when menu is active
    } else {
      //lenis.start(); // Re-enable scroll when menu is inactive
      setTimeout(() => {
        menuContent.scrollTop = 0;
      }, 800);
    }
  });

}
document.addEventListener('DOMContentLoaded', initMenuButton);

// footer intersection observer
function observeFooterInView() {
  const footer = document.querySelector('footer');

  if (!footer) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.add('footer_inview');
        } else {
          document.body.classList.remove('footer_inview');
        }
      });
    },
    {
      root: null, // viewport
      threshold: 0 // trigger as soon as any part is visible
    }
  );

  observer.observe(footer);
}
document.addEventListener('DOMContentLoaded', observeFooterInView);


// search suggestions
function searchSuggestions() {
  const inputField = document.querySelector(".form input[type='search']");
  const suggestions = document.querySelectorAll(".suggestion a");

  suggestions.forEach((suggestion) => {
    suggestion.addEventListener("click", (event) => {
      event.preventDefault();
      inputField.focus();
      inputField.value = suggestion.textContent;
    });
  });
}
document.addEventListener("DOMContentLoaded", searchSuggestions);


function scrapbook() {
  const items = document.querySelector('section[data-module="scrapbook"] .cell:nth-child(1) .items');

  if( items ){
    
    const images = items.querySelectorAll('.item img');

    images.forEach(img => {
      // random rotation -5 to +5 degrees
      const rotation = (Math.random() * 10 - 5).toFixed(2);

      // random X & Y translation -5px to +5px
      const translateX = (Math.random() * 10 - 5).toFixed(2);
      const translateY = (Math.random() * 10 - 5).toFixed(2);

      // Apply inline transform
      img.style.transform = `rotate(${rotation}deg) translate3d(${translateX}px, ${translateY}px, 0)`;
    });


    function moveTopElementToBack(parent) {
      const topElement = parent.lastElementChild; // The "top" one visually
      if (topElement) {
        parent.insertBefore(topElement, parent.firstElementChild); // Move it to the front
      }
    }

    items.addEventListener('click', function () {
      moveTopElementToBack(this);
    });

  }
}
document.addEventListener("DOMContentLoaded", scrapbook);

// Utility: format seconds into M:SS
function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
}
// Enhance all videoplayer sections
const videoPlayers = document.querySelectorAll('section[data-module="videoplayer"]');
videoPlayers.forEach(section => {
  const itemsElement = section.querySelector('.items');
  const video = section.querySelector('video');

  const controls = document.createElement('div');
  controls.classList.add('controls', 'item');

  const playPauseBtn = document.createElement('button');
  playPauseBtn.textContent = video.paused ? 'Play' : 'Pause';
  controls.appendChild(playPauseBtn);

  const timeDisplay = document.createElement('span');
  timeDisplay.textContent = `0:00 / 0:00`;
  controls.appendChild(timeDisplay);

  const muteBtn = document.createElement('button');
  muteBtn.textContent = video.muted ? 'Unmute' : 'Mute';
  controls.appendChild(muteBtn);

  itemsElement.appendChild(controls);

  // Button handlers
  video.addEventListener('click', () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
  playPauseBtn.addEventListener('click', () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  muteBtn.addEventListener('click', () => {
    video.muted = !video.muted;
    muteBtn.textContent = video.muted ? 'Unmute' : 'Mute';
  });

  // Keep button text in sync with video events
  video.addEventListener('play', () => {
    playPauseBtn.textContent = 'Pause';
  });

  video.addEventListener('pause', () => {
    playPauseBtn.textContent = 'Play';
  });

  // Time updates
  video.addEventListener('timeupdate', () => {
    const current = formatTime(video.currentTime);
    const duration = formatTime(video.duration || 0);
    timeDisplay.textContent = `${current} / ${duration}`;
  });

  video.addEventListener('loadedmetadata', () => {
    timeDisplay.textContent = `0:00 / ${formatTime(video.duration)}`;
  });
});


const textBlowupSections = document.querySelectorAll('[data-module="text_blowup"]');
textBlowupSections.forEach((element) => {
  const text = element.querySelector('.text');

  gsap.set(text, {
    y: "-20%"
  });
  gsap.to(text, {
    y: "20%",
    ease: "none",
    scrollTrigger: {
      trigger: element,
      start: "top bottom",
      end: "bottom top",
      scrub: true,
      toggleActions: "play none none reverse"
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const product_single = document.querySelector('section.product_single');
  if( !product_single ){
    return;
  }
  const product_gallery = product_single.querySelector('.product-gallery');
  const items = product_gallery.querySelector('.items');
  const pagination = product_gallery.querySelector('.pagination');
  const itemNodes = items.querySelectorAll(".item");
  const itemCount = itemNodes.length;

  let currentIndex = 0;

  function updateDots(index) {
    const dots = pagination.querySelectorAll(".dot");
    dots.forEach((d, i) => d.classList.toggle("active", i === index));
  }

  function setupPagination() {
    if (window.innerWidth < 769 && itemCount > 1) {
      pagination.innerHTML = "";
      for (let i = 0; i < itemCount; i++) {
        const dot = document.createElement("div");
        dot.classList.add("dot");
        if (i === 0) dot.classList.add("active");
        pagination.appendChild(dot);
      }

      items.addEventListener("scroll", () => {
        const index = Math.round(items.scrollLeft / items.clientWidth);
        currentIndex = index;
        updateDots(index);
      });

      // Click to go to next item
      items.addEventListener("click", () => {
        currentIndex = (currentIndex + 1) % itemCount;
        itemNodes[currentIndex].scrollIntoView({ behavior: "smooth" });
        updateDots(currentIndex);
      });
    } else {
      pagination.innerHTML = "";
    }
  }

  setupPagination();
  window.addEventListener("resize", setupPagination);
});

window.addEventListener("load", () => {
  
  const fullpageElements = document.querySelectorAll('[data-module="fullpage_element"]');
  fullpageElements.forEach((element) => {
    const bg = element.querySelector(".background");
    const heading = element.querySelector(".heading");

    let split = SplitText.create(heading, {
      type: "lines, words, chars",
      linesClass: "clip-text"
    });

    gsap.set(bg, {
      y: "-20%"
    });
    gsap.to(bg, {
      y: "20%",
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        toggleActions: "play none none reverse"
      }
    });

    gsap.fromTo(
      split.chars,
      {
        yPercent: 200
      },
      {
        yPercent: 0,
        ease: "none",
        stagger: {
          each: 0.02,
          from: "random"
        },
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end: "center center",
          scrub: true,
          toggleActions: "play none none reverse"
        }
      }
    );
  });

  const splitElements = document.querySelectorAll('[data-module="split_element"]:first-child .media');
  splitElements.forEach((element) => {
    const bg = element.querySelector('[data-module="split_element"]:first-child .media video');

    if( !bg ){
      return;
    }
    gsap.set(bg, {
      y: "-20%"
    });
    gsap.to(bg, {
      y: "20%",
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        toggleActions: "play none none reverse"
      }
    });

  });

});


/*
Shopify inbox toggle chat
window.addEventListener("load", () => {
    const chatElement = document.querySelector("inbox-online-store-chat");
    const liveChatElements = document.querySelectorAll('a.live-chat');
    if( liveChatElements && chatElement ){
      liveChatElements.forEach(element => {
        element.addEventListener('click', (event) => {
          event.preventDefault();

          console.log('click, a.live-chat');
          
          const isOpen = chatElement.getAttribute('is-open');
          if (isOpen === "true") {
            //console.log("Chat is open");
            chatElement.shadowRoot.querySelector("button.chat-app--close-button").click();
          } else {
            //console.log("Chat is closed");
            chatElement.shadowRoot.querySelector("button.chat-toggle").click();
          }

        });
      });
    }
});
*/

/* Hubspot chat toggle */
window.addEventListener("load", () => {
  const liveChatElements = document.querySelectorAll("a.live-chat");
  if (!liveChatElements?.length) return;

  const whenReady = (cb) => {
    if (window.HubSpotConversations?.widget) return cb();

    window.hsConversationsOnReady = window.hsConversationsOnReady || [];
    window.hsConversationsOnReady.push(cb);
  };

  liveChatElements.forEach((el) => {
    el.addEventListener("click", (event) => {
      event.preventDefault();

      whenReady(() => {
        window.HubSpotConversations.widget.close();
        window.HubSpotConversations.widget.open();
      });
    });
  });
});
